  import defaultClient from '@src/api/clients/default';

  const URL = (path) => {
    return `dashboard/daily-pulse/${path}/`
  }

  export function fetchDailyPulseByClient(payload = {}) {
    return defaultClient.request({
      url: URL('client'),
      payload
    })
  }

  export function fetchDailyPulseByChannel(payload = {}) {
    return defaultClient.request({
      url: URL('channel'),
      payload
    })
  }

  export function fetchDailyPulseByVertical(payload = {}) {
    return defaultClient.request({
      url: URL('vertical'),
      payload
    })
  }

  export function fetchDailyPulseByCampaign(payload = {}) {
    return defaultClient.request({
      url: URL('campaign'),
      payload
    })
  }

  export function fetchDailyPulseByClientDate(payload = {}) {
    return defaultClient.request({
      url: URL('client-date'),
      payload
    })
  }

  export function fetchDailyPulseByState(payload = {}) {
    return defaultClient.request({
      url: URL('state'),
      payload
    })
  }

  export function fetchDailyPulseByCity(payload = {}) {
    return defaultClient.request({
      url: URL('city'),
      payload
    })
  }

  export function fetchDailyPulseByCounty(payload = {}) {
    return defaultClient.request({
      url: URL('county'),
      payload
    })
  }

  export function fetchDailyPulseByDMA(payload = {}) {
    return defaultClient.request({
      url: URL('dma'),
      payload
    })
  }

  export function fetchDailyPulseByTerritory(payload = {}) {
    return defaultClient.request({
      url: URL('territory'),
      payload
    })
  }

  export function fetchDailyPulseByTerritoryCampaign(payload = {}) {
    return defaultClient.request({
      url: URL('territory-campaign'),
      payload
    })
  }

  export function triggerDailyPulseBackfill(payload = {}) {
    return defaultClient.request({
      url: URL('collect-report-range'),
      method: 'POST',
      payload,
    })
  }

  export function fetchDailyPulseBackfillStatus(payload = {}) {
    return defaultClient.request({
      url: URL('collect-report-range/status'),
      method: 'GET',
      payload,
    })
  }
